export const ASSIGNMENT_LABEL_TEXT = {
	actionLabelMenuItems: {
		reassign: 'Reassign to the same driver',
		assignAnother: 'Assign to another driver',
		assignFull: 'Assign to full assignment',
		unassign: 'Unassign',
		sendNotification: 'Notify crew member',
		confirmAssignment: 'Manually confirm assignment',
		toActual: 'Mark as completed',
		unmergeAndClean: 'Unmerge & clean segments',
	},
	multiRideLabel: 'Multi-ride',
	multiRideTooltip: 'This work assignment covers multiple rides',
	noAssignment: 'No crew member assigned',
	assignLabel: 'Assign',
	postBreakdown: 'Post breakdown',
	voided: 'Voided',
};
